import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, initializing } = useAuth();
  if (initializing || user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="font-display text-2xl text-neutral-500 animate-pulse">Immersive</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/welcome" replace />;
  return children;
}
